export default "__VITE_ASSET__IPDp2NE0__"